import { ORPCError } from "@orpc/client";
import type { DirectoryOrganization } from "@repo/api/client";

export type DirectoryLocation = DirectoryOrganization["locations"][number];
export type DirectorySpecialty = { id: string; name: string };

/** Show a stored 10-digit number as (432) 555-0107. Anything else as stored. */
export function formatPhone(digits: string | null | undefined): string {
	if (!digits) {
		return "";
	}
	if (!/^\d{10}$/.test(digits)) {
		return digits;
	}
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function formatLocation(location: DirectoryLocation): string {
	return [location.address, location.city, location.state, location.zip]
		.filter(Boolean)
		.join(", ");
}

/**
 * The API's message when it's one meant for people (a refusal or a validation
 * problem), otherwise `fallback`. Server errors only ever say "Internal server
 * error".
 */
export function userFacingMessage(error: unknown, fallback: string): string {
	if (error instanceof ORPCError && error.status < 500 && error.message) {
		return error.message;
	}
	return fallback;
}
